export const WorkTypeTypes = {
  work: 'work',
  standby: 'standby',
  onCall: 'on_call',
};

export const WorkTypeTypeNames = {
  [WorkTypeTypes.work]: 'Arbete',
  [WorkTypeTypes.standby]: 'Beredskap',
  [WorkTypeTypes.onCall]: 'Jour',
};
